export default __webpack_public_path__ + "static/media/homebg.125d61ff.jpg";